import React from "react";
import PropTypes from "prop-types";
import styles from "./Button.module.scss";
import { LoadingSpinner } from "../Loading/Loading";

export default function Button({
  label,
  type,
  onClick,
  className,
  disabled,
  dataTestId,
  isLoading,
  loadingText,
  icon,
}) {
  return (
    <button
      className={`${styles.Button} ${styles[type]} ${className}`}
      disabled={disabled}
      onClick={onClick}
      data-testid={dataTestId}
    >
      <div
        className={`d-flex align-items-center justify-content-center ${
          icon || isLoading ? styles.WithIcon : ""
        }`}
      >
        {isLoading ? (
          <>
            <LoadingSpinner size="Small" />
            {loadingText}
          </>
        ) : (
          <>
            {icon} {label}
          </>
        )}
      </div>
    </button>
  );
}
Button.propTypes = {
  label: PropTypes.any,
  type: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  dataTestId: PropTypes.string,
  loadingText: PropTypes.string,
  isLoading: PropTypes.bool,
  icon: PropTypes.any,
};

Button.defaultProps = {
  label: "Submit",
  type: "Primary",
  onClick: undefined,
  className: "",
  disabled: false,
  dataTestId: "Button",
  isLoading: false,
  loadingText: "",
  icon: undefined,
};

export const ButtonLink = ({
  label,
  type,
  className,
  dataTestId,
  icon,
  href,
  textClassName,
  anchorProps = {},
}) => (
  <a
    className={`${styles.Button} ${styles[type]} ${className}`}
    data-testid={dataTestId}
    href={href}
    {...anchorProps}
  >
    <div className={`d-flex align-items-center ${textClassName} ${icon ? styles.WithIcon : ""}`}>
      {icon} {label}
    </div>
  </a>
);

ButtonLink.propTypes = {
  label: PropTypes.any,
  type: PropTypes.string,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  href: PropTypes.string,
  anchorProps: PropTypes.shape({
    rel: PropTypes.string,
    target: PropTypes.string,
  }),
  icon: PropTypes.any,
  textClassName: PropTypes.string,
};

ButtonLink.defaultProps = {
  type: "Primary",
  className: "",
  dataTestId: "ButtonLink",
  icon: undefined,
  textClassName: "",
};
